import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OktaAuthService } from '../../app.service';
import { constants } from '../../shared/constants';
import { ErrorService } from '../../shared/services/error.service';
import { UserPreferenceService } from '../../shared/services/userpreferences.service';

@Component({
  selector: 'app-nomenulayout',
  templateUrl: './nomenulayout.component.html',
  styleUrls: ['./nomenulayout.component.scss']
})
export class NoMenuLayoutComponent implements OnInit {
  active = false;
  isCollapsedNav = true;
  languages = [
    {name: 'EN', label: 'English version', lang: 'en', current: this.active},
    {name: 'FR', label: 'Version française', lang: 'fr', current: this.active},
    {name: 'NL', label: 'Nederlandse versie', lang: 'nl', current: this.active},
    {name: 'SE', label: 'Svensk version', lang: 'se', current: this.active},
    {name: 'DE', label: 'Deutsche version', lang: 'de', current: this.active},
    
  ];
  regions = [
    { name: "Belgium", value: "be", current: this.active},
    { name: "China", value: "cn", current: this.active},
    { name: "Denmark", value: "dk", current: this.active},
    { name: "France", value: "fr", current: this.active},
    { name: "Germany", value: "de", current: this.active},
    { name: "Global", value: "global", current: this.active},
    { name: "Maghreb & West Africa", value: "ar-ma", current: this.active},
    { name: "Netherlands", value: "nl", current: this.active},
    { name: "Norway", value: "no", current: this.active},
    { name: "South Africa", value: "za", current: this.active},
    { name: "Sweden", value: "se", current: this.active},
    { name: "United Kingdom", value: "uk", current: this.active}
  ]

  // default to global EN
  selectRegion = { name: "Global", value: "global", current: true};
  selectLanguage = {name: 'EN', label: 'English version', lang: 'en', current: true};
  userObject: any;
  userAdmin = false;
  changeTenants = false;
  tenantNameAdmin: string;

  constructor(private translate: TranslateService, private auth: OktaAuthService, private userPref: UserPreferenceService, private errorService: ErrorService) {}

  ngOnInit(): void {
    this.auth.getUserDetails().then(val => {
      this.userObject = val;
      if(this.userObject.groups.filter(g => g.startsWith("ADMINS_")).length > 0){
        this.tenantNameAdmin = this.userObject.groups.filter(g => g.startsWith("ADMINS_"))[0].split("_")[1];

        // check to see if multiple tenants are available, and if one has been selected
        let tenants = JSON.parse(sessionStorage.getItem("okta-tenants"));

        // if the user is an admin, and can see multiple tenants then enable the change tenants feature
        if(tenants && tenants.availableTenants.length > 1){ 
          // allow the changing of tenants
          this.changeTenants = true;

          // if the user is an admin of the selected tenant then allow the admin menu item
          if(tenants.selectedTenant && tenants.selectedTenant === this.tenantNameAdmin){
            this.userAdmin = true;
          }
        }else{
          // if the user is an admin but is only a user for one tenant then allow it
          this.userAdmin = true;
        }

      }else{
        // if the user is not an admin
        this.userAdmin = false;
      }
    
    });

    // selected language
    this.languages.forEach(lang => { 
      if(lang.lang === this.translate.currentLang){
        this.selectLanguage = lang;
        lang.current = true;
      } 
    });
    
    // get region from preferencs
    this.userPref.getUserPreferences()
      .then(res => {
        this.regions.forEach(reg => { 
          if(reg.value === res.region){
            this.selectRegion = reg;
            reg.current = true;
          } 
        });
      });
  }

  toggleCollapseNav() {
    this.isCollapsedNav = !this.isCollapsedNav;
  }

  logout(){
    this.auth.logout();
  }

  changeLanguage(l) {
    this.selectLanguage = l;
    this.languages.forEach(lang => { 
      lang.current = this.active; 
    });
    l.current = !l.current;
    this.translate.use(l.lang);

    // update user preferences
    this.userPref.userPreferencesUpdateSingle(constants.local.userPreferenceLanguage, l.lang.toLowerCase());
  }

  changeRegion(l) {
    this.selectRegion = l;
    this.regions.forEach(reg => { 
      reg.current = this.active; 
    });
    l.current = !l.current;

    // update user preferences
    this.userPref.userPreferencesUpdateSingle(constants.local.userPreferenceRegion, l.value.toLowerCase());
  }

  scrollUp(){ 
    window.scrollTo(0, 0);
  }

}
